<template>
  <h2 class="pb-2 border-bottom">PRP Treatment Options We Can Offer</h2>
  <ul>
    <li><strong>PRP for Facial Rejuvenation (“Vampire Facial”)</strong>
      <ul>
        <li>Stimulates collagen production and improves skin texture</li>
        <li>Reduces fine lines, wrinkles, and acne scars</li>
        <li>Restores glow and elasticity</li>
      </ul>
    </li>
    <li><strong>PRP for Hair Restoration</strong>
      <ul>
        <li>Strengthens hair follicles and reduces hair loss</li>
        <li>Stimulates new hair growth</li>
        <li>Ideal for androgenic alopecia (male/female pattern baldness)</li>
      </ul>
    </li>
    <li><strong>PRP for Joint & Pain Therapy</strong>
      <ul>
        <li>Helps with arthritis, tendonitis, and injury recovery</li>
        <li>Reduces inflammation and pain in joints and muscles</li>
        <li>Often used for knee, shoulder, and elbow pain</li>
      </ul>
    </li>
    <li><strong>PRP for Sexual Wellness</strong>
      <ul>
        <li>O-Shot (for women) – Improves sexual function, arousal, and urinary incontinence</li>
        <li>P-Shot (for men) – Enhances erectile function and sensitivity</li>
      </ul>
    </li>
    <li><strong>PRP for Scar & Stretch Mark Reduction</strong>
      <ul>
        <li>Improves skin texture and reduces pigmentation</li>
        <li>Effective for acne scars, post-surgical scars, and stretch marks</li>
      </ul>
    </li>
  </ul>

  <h2 class="pb-2 border-bottom">PRP Procedure Overview</h2>
  <ul>
    <li><strong>Blood Draw</strong> – A small amount of blood is taken from the patient</li>
    <li><strong>Centrifuge Process</strong> – Blood is spun to separate platelet-rich plasma</li>
    <li><strong>PRP Application</strong> – Injected or applied via microneedling based on the treatment</li>
    <li><strong>Recovery & Aftercare</strong> – Minimal downtime, mild swelling or redness for 24-48 hours</li>
  </ul>
  <p><strong>Procedure Time:</strong> 30-60 minutes</p>
  <p><strong>Recovery Time:</strong> 1-3 days for skin treatments, minimal for hair and joint treatments</p>
</template>

<script>
export default {
  name: 'PRPMicroneedlingFacialContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
